(function () {
  const DESIGNER_SELECTOR = '.setubridgeProductDesigner';
  const BUTTON_TEXT = 'Upload Artwork';
  const POPUP_CLASS = 'sbProduct-Designer-Popup-Html';
  const UPLOAD_SUGGESTION_SELECTOR = '.pd_upload_file_suggestion';

  // ── Upload-button renaming ────────────────────────────────────────────────

  function renameButton(button) {
    button.textContent = BUTTON_TEXT;
  }

  function observeDesignerContainer(container) {
    // Button may already exist if the script loaded after Setubridge injected it
    const existingButton = container.querySelector('button');
    if (existingButton) {
      renameButton(existingButton);
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) continue;

        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const button = node.matches('button') ? node : node.querySelector('button');
          if (!button) continue;

          renameButton(button);
          observer.disconnect();
          return;
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  // ── Upload-suggestion hint injection ─────────────────────────────────────

  function buildHintBlock() {
    const strings = window.productCustomizationStrings || {};
    const lines = [
      strings.uploadArtworkHintSvg,
      strings.uploadArtworkHintRaster,
      strings.uploadArtworkHintFormats,
      strings.uploadArtworkHintProof,
    ];

    const wrapper = document.createElement('div');
    wrapper.className = 'pd-upload-artwork-hints';

    lines.forEach(function (text) {
      if (!text) return;
      const p = document.createElement('p');
      p.textContent = text;
      wrapper.appendChild(p);
    });

    return wrapper;
  }

  function stripForeignNodes(suggestion) {
    Array.from(suggestion.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE || !node.classList.contains('pd-upload-artwork-hints')) {
        suggestion.removeChild(node);
      }
    });
  }

  function appendHints(suggestion) {
    // Remove all pre-existing content from Setubridge
    while (suggestion.firstChild) {
      suggestion.removeChild(suggestion.firstChild);
    }

    suggestion.appendChild(buildHintBlock());

    // Watch for any nodes Setubridge adds after our block and remove them
    const guardian = new MutationObserver(function () {
      stripForeignNodes(suggestion);
    });

    guardian.observe(suggestion, { childList: true });
  }

  function injectHintsIntoPopup(popup) {
    const suggestion = popup.querySelector(UPLOAD_SUGGESTION_SELECTOR);

    if (suggestion) {
      appendHints(suggestion);
      return;
    }

    // .pd_upload_file_suggestion not yet rendered — watch for it inside the popup
    const innerObserver = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) continue;

        // Check newly added nodes and their subtrees
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const target = node.matches(UPLOAD_SUGGESTION_SELECTOR)
            ? node
            : node.querySelector(UPLOAD_SUGGESTION_SELECTOR);

          if (!target) continue;

          appendHints(target);
          innerObserver.disconnect();
          return;
        }
      }
    });

    innerObserver.observe(popup, { childList: true, subtree: true });
  }

  function observeForPopup() {
    // Popup may already be in the DOM when the script loads
    const existing = document.querySelector('.' + POPUP_CLASS);
    if (existing) {
      injectHintsIntoPopup(existing);
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) continue;

        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const popup = node.classList.contains(POPUP_CLASS)
            ? node
            : node.querySelector('.' + POPUP_CLASS);

          if (!popup) continue;

          injectHintsIntoPopup(popup);
          observer.disconnect();
          return;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    document.querySelectorAll(DESIGNER_SELECTOR).forEach(observeDesignerContainer);
    observeForPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
